<div class="keen-slider" #sliderRef *ngIf="items.length">
  <card-gallery
    class="keen-slider__slide"
    *ngFor="let item of items"
    [item]="item"
    (clicked)="clicked($event)"
  ></card-gallery>
</div>
